/* src/app/modules/finanzas/finanzas-tabs.component.css */
/*# sourceMappingURL=finanzas-tabs.component.css.map */
